import BenchlingConfig from 'BenchlingConfig';

/**
 * Whether the Agents (routines) UI should be available. Agents require the assistant agent and at
 * least one routine trigger type (time-based or event-based); without a trigger type, an agent
 * cannot be created. Gate every Agents entry point (sidebar nav, settings tabs) on this so we never
 * surface an entry point that leads to a non-functional Agents surface.
 */
export function isAgentsFeatureEnabled(): boolean {
  return (
    BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT &&
    (BenchlingConfig.LLM_ENABLE_ROUTINES_TIME_BASED || BenchlingConfig.LLM_ENABLE_ROUTINES_EVENT_BASED)
  );
}

/**
 * Whether agents that run on a schedule are available. The two trigger types are configured
 * independently (event-based is off by default and unavailable on GxP tenants), so anything that
 * commits the user to one specific trigger type must check that type rather than
 * {@link isAgentsFeatureEnabled}, which is satisfied by either.
 */
export function isTimeBasedAgentsEnabled(): boolean {
  return BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT && BenchlingConfig.LLM_ENABLE_ROUTINES_TIME_BASED;
}

/** Whether agents that run in response to an event are available. See {@link isTimeBasedAgentsEnabled}. */
export function isEventBasedAgentsEnabled(): boolean {
  return BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT && BenchlingConfig.LLM_ENABLE_ROUTINES_EVENT_BASED;
}
